module.exports = __webpack_public_path__ + "static/media/adventureMountainIcon.6adfe1cd.png";